export default "__VITE_ASSET__Dj8LTlu9__"